import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

import type {
  PetWorthRoyaleHomepageData,
  PetWorthRoyaleHomepageParam,
} from './apiTypes'
import {
  petWorthRoyaleHomepageMock,
  userPeak2026HomepageUseMock,
} from './mockData'

export const get_activity_info = async (params = {}) => {
  const res = await http.post(
    '/live/commonactivity/get_activity_info',
    {
      ...params,
    },
    {
      store: window.store,
    }
  )
  return res.data.data
}

/**
 * 崽崽驾到养成首页
 * POST /live/activity/pet_worth_royale_homepage
 */
export const get_homepage = createAsyncThunk<
  PetWorthRoyaleHomepageData,
  PetWorthRoyaleHomepageParam | void
>('UserPeak2026/get_homepage', async (p = {}) => {
  const resp = await http.post(
    '/live/activity/pet_worth_royale_homepage',
    {
      ...window.store.getState().env.deviceinfo,
      ...p,
    },
    {
      store: window.store,
    }
  )
  return resp.data?.data
})

/**
 * 完成新手引导
 * POST /live/activity/pet_worth_royale_newbie_guide_finish
 */
export const newbie_guide_finish = createAsyncThunk<{err_msg: string}, void>(
  'UserPeak2026/newbie_guide_finish',
  async () => {
    const resp = await http.post(
      '/live/activity/pet_worth_royale_newbie_guide_finish',
      {
        ...window.store.getState().env.deviceinfo,
      },
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

export type InitialStateType = PetWorthRoyaleHomepageData

const initialState: InitialStateType = {}

export const UserPeak2026Slice = createSlice({
  name: 'UserPeak2026',
  initialState,
  reducers: {
    updateHomepage: (state, action) => {
      Object.assign(state, {
        ...action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default UserPeak2026Slice.reducer

export const UserPeak2026Actions = UserPeak2026Slice.actions

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.UserPeak2026 as InitialStateType
  })
  return data
}
